module.exports = __webpack_public_path__ + "static/media/create_funnel_sample_mobile.334afac3.png";